import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

// API for creating dealer entry
export const postDealerEntry = (payload,headers) => {
  return Axios.post(`addDealerDetails`, payload, {
    headers
  });
};

// API for updating dealer details
export const putDealerEntry = (payload) => {
  let token = sessionStorage.getItem("token");
  return Axios.put(`updateDealerDetails`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// API for getting list of all dealer
export const getDealerEntry = (pageNo,fkUserId,role,headers) => {
  return Axios.get(`getAllDealerDetails/${pageNo}?fkUserId=${fkUserId}&role=${role}`, {
    headers
  });
};

// API for getting list of all dealer by from and to date
export const getDealerEntryByDate = (pageNo, fromDate, toDate) => {
  const role = sessionStorage.getItem('role');
  const fkUserId = sessionStorage.getItem('pkUserId');
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `getDealerDetailsBetWeenTwoDates/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

// API for getting list of pdf all dealer by from and to date
export const getDealerEntryPdfDownload = (fromDate,toDate) => {
  let fileType = ["Pdf"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `getDealerReportPdf?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  )
  .then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `dearlerreport.pdf`);
  });
};

export const getDealerEntryExcelDownload = (fromDate, toDate) => {
  let fileType = ["Excel"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let token = sessionStorage.getItem("token");
  return Axios.get(`getDealerReportPdf?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&toDate=${toDate}`,
  {
    headers: {Authorization: `Bearer ${token}`},
    responseType: "arraybuffer",
  })
  .then((result) => {
    let blob = new Blob([result.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
    fileSaver.saveAs(blob, "dealerListBetweenTwoDate.xlsx");
  });
};

// API for getting list of all dealer for Drop Down
export const getDealerEntryforDropDown = (headers) => {
  return Axios.get(`getDealerNameDropDown`, {
    headers
  });
};

// API for getting details of dealer by id
export const getDealerEntryById = (headers,pk_dealer_id) => {
  return Axios.get(`getDealerDetailsById/${pk_dealer_id}`, {
    headers
  });
};

export const getDealerLExcel = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(`getDealerListExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}`, {
    headers: {Authorization: `Bearer ${token}`},
    responseType: "arraybuffer",
  })
};